import { Field, SchemaFieldType } from './entity';

export function validatePrimaryField(data: Record<string, Omit<Field, 'inherited'>>): boolean {
  const fields = Object.entries(data).map(([key, value]) => ({ key, ...value }));

  if (fields.length === 0) {
    return true;
  }

  const primaryFields = fields.filter((field) => field.primary);
  if (primaryFields.length > 1) {
    return false;
  }

  const field = primaryFields[0];
  if (!field) {
    return false;
  }

  if (field.definition.type !== SchemaFieldType.STRING) {
    return false;
  }

  if (field.definition.required !== true) {
    return false;
  }

  return true;
}
